import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore.js";

const PIN_KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "clear", "0", "back"];

export function PinLogin() {
  const [pin, setPin] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const staff = useAuthStore((state) => state.staff);
  const accessibleStores = useAuthStore((state) => state.accessibleStores);
  const error = useAuthStore((state) => state.error);
  const login = useAuthStore((state) => state.login);
  const clearError = useAuthStore((state) => state.clearError);
  const navigate = useNavigate();

  if (staff) {
    return <Navigate to={accessibleStores.length > 1 ? "/select-store" : "/"} replace />;
  }

  const handleKey = (key: string) => {
    clearError();
    if (key === "clear") {
      setPin("");
      return;
    }
    if (key === "back") {
      setPin((prev) => prev.slice(0, -1));
      return;
    }
    if (pin.length >= 6) return;
    setPin((prev) => prev + key);
  };

  const handleSubmit = async () => {
    if (pin.length < 4) return;
    setSubmitting(true);
    const ok = await login(pin);
    setSubmitting(false);
    if (ok) {
      setPin("");
      const stores = useAuthStore.getState().accessibleStores;
      navigate(stores.length > 1 ? "/select-store" : "/", { replace: true });
    } else {
      setPin("");
    }
  };

  return (
    <div className="app-shell" style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
      <div className="card" style={{ width: 380 }}>
        <h1 style={{ textAlign: "center", fontSize: 22 }}>AIレジ ログイン</h1>
        <p style={{ textAlign: "center", color: "var(--color-text-muted)" }}>PIN（4〜6桁）を入力してください</p>
        <div className="pin-display">{"●".repeat(pin.length) || " "}</div>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="pin-pad">
          {PIN_KEYS.map((key) => (
            <button
              key={key}
              onClick={() => handleKey(key)}
              disabled={submitting}
              aria-label={key === "clear" ? "全消去" : key === "back" ? "一文字削除" : key}
            >
              {key === "clear" ? "C" : key === "back" ? "⌫" : key}
            </button>
          ))}
        </div>
        <button
          className="btn btn-primary btn-block btn-lg"
          style={{ marginTop: 16 }}
          disabled={pin.length < 4 || submitting}
          onClick={() => void handleSubmit()}
        >
          {submitting ? "確認中..." : "ログイン"}
        </button>
      </div>
    </div>
  );
}
